<script>
    import TeamPickerForm from "../Teams/Form/Picker";
    import ClubSelect from './ClubSelect';
    import HtmlCharity from "./HtmlCharity.vue";
    import ValueStorage from '../Utility/InlineTemplates/ValueStorage.vue';
    import GroupSelectInput from '../Utility/Forms/InputFields/GroupSelect.vue';

    export default {
        components: {
            TeamPickerForm,
            ClubSelect,
            HtmlCharity,
            ValueStorage,
            GroupSelectInput,
        },
        props: {
            participant: {
                type: Object,
                required: true
            },
            searchTransferableRegistrationCategories: {
                type: Boolean,
                required: false,
                default: false,
            },
            onlyTeamTicket: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                team_id: null,
                field_values: {},
                registration_categories: {},
            }
        },
        created() {
            var self = this;
            this.team_id = this.participant.team_id;

            if (Object.hasOwnProperty.call(this.participant, 'additional_participant_values') && this.participant.additional_participant_values.length) {
                this.participant.additional_participant_values.forEach(function (item) {
                    Vue.set(self.field_values, item.addition_id, item.addition_multiple_option_id);
                });
            }

            if (this.searchTransferableRegistrationCategories) {
                this.getTransferableRegistrationCategoriesList();
            }
        },
        methods: {
            saveForm() {
                this.$refs.cakeForm.submit();
            },

            getTransferableRegistrationCategoriesList() {
                let url = `/api/internal/registration-categories/transferable-registration-categories-list/${this.participant.occasion_id}.json?rc_id=${this.participant.registration_category_id}`;
                if (this.onlyTeamTicket) {
                    url += `&only_team_ticket=true`;
                }
                axios.get(url, {headers: {'Accept': 'application/json'}}).then(res => {
                    this.registration_categories = res.data;
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/ParticipantEditForm.vue